import api from '../callApi';

const completePoll = (
    apiRequestData,
    answerId,
    answerText,
    actionCompletedTime,
    skipEndCard,
    userAnswerId
) => {
    const request = {
        answerId,
        text: answerText,
        actionCompletedTime,
        skipEndCard,
        userAnswerId,
        ...apiRequestData
    };

    const endpoint = userAnswerId ? 'Widget/UpdatePollAsync' : 'Widget/CompletePollAsync';
    return api.post(endpoint, request, { useFingerprint: true }).then(response => {
        return response;
    });
};

export default completePoll;
